module.exports = __webpack_public_path__ + "01f43047/img/search-filter-icon.c4751a52.svg";